module.exports = __webpack_public_path__ + "img/img_5_technology_retail@3x.43fc724f.png";